<template>
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.07558 11.9244H0V9.07558H9.07558V0H11.9244V9.07558H21V11.9244H11.9244V21H9.07558V11.9244Z"
            fill="currentColor" />
    </svg>
</template>